// extracted by mini-css-extract-plugin
export var md = "_24-4";
export var semantic = "_24-5";
export var sm = "_24-3";
export var text = "_24-6";
export var toggleInput = "_24-0";
export var toggleSwitch = "_24-1";
export var xs = "_24-2";